import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import {toFixedFeatureCost, TAX_DISCOUNT_PCT, getFeatureUnit, getPriceWithCurrency} from "../../../misc/helpers";
import {cartItemInterface} from "../../shoppingCart/cartItemInterface";
import {getPriceWithIncluded} from "../../../misc/priceFunctions";
import FeaturePriceInput from "./featurePriceInput";

const FeatureInfoPrice = (props) => {

  let {
    mainFeaturePrice = false,
    selectionFeatureInfo,
    showDiscount = false,
    fabricatorData,
    isPhoneNumberValidated,
    intl,
    unitAfter,
    withTotalSlabCost,
    cartItemEditFeature,
    qtActiveCategory,
    showPrice,
  } = props;
  const fabricatorSettings = fabricatorData.settings;

  if (mainFeaturePrice && fabricatorSettings.leadCaptureShoppingCart && !isPhoneNumberValidated) {
    return null
  }

  if ((typeof showPrice !== 'undefined') && !showPrice && !(document.kvConfig.isBackend && selectionFeatureInfo && selectionFeatureInfo.dbFeature
    && selectionFeatureInfo.dbFeature.priceEditable)) {
    return null
  }

  selectionFeatureInfo = props.feature || selectionFeatureInfo;

  let quantity = 1;
  if (mainFeaturePrice) { // price is changing depending on quantity
    quantity = (props.accItemQuantity || (props.accItemQuantity === 0))
      ? props.accItemQuantity
      : props.selectionInfoQuantity || 1
  }
  const price = toFixedFeatureCost(selectionFeatureInfo, quantity, qtActiveCategory, withTotalSlabCost, cartItemEditFeature);
  const salePercentage = TAX_DISCOUNT_PCT;
  const priceOld = Math.trunc((price + price*salePercentage/100) * 100) / 100;

  if (mainFeaturePrice) {
    return (
      <div className="product-action__price">
        <div className="product-action__price-num bold">
          {getPriceWithIncluded(price, selectionFeatureInfo, fabricatorData, intl.messages)}
        </div>
        {/*<div className="product-action__price-unit bold">(${selectionFeatureInfo.dbFeature.unit || "Each"})</div>*/}
      </div>
    )
  }

  const unit = getFeatureUnit(selectionFeatureInfo, intl, fabricatorData, quantity);

  const getPriceSection = () => {

    // if unitAfter then it is row item, we don't need it to show in row view
    if (!unitAfter && document.kvConfig.isBackend && selectionFeatureInfo && selectionFeatureInfo.dbFeature
      && selectionFeatureInfo.dbFeature.priceEditable) {
      return <FeaturePriceInput unit={unit} feature={selectionFeatureInfo} price={price} showPrice={showPrice}/>
    }

    return (
      <div className="product-info__edit flex flex--inline">
        <span className="product-info__price-new bold">
          {!price
            ? getPriceWithIncluded(price, selectionFeatureInfo, fabricatorData, intl.messages)
            : unitAfter
              ? getPriceWithCurrency(fabricatorSettings, price, selectionFeatureInfo)
              : `${getPriceWithCurrency(fabricatorSettings, price, selectionFeatureInfo)} (${unit})`}
        </span>
        {price && unitAfter ? <span className="product-info__unit bold">({unit})</span> : null}
      </div>
    )
  }

  return (
    <div className="product-info__price">
      {showDiscount && price ? <span className="product-info__price-old">{getPriceWithCurrency(fabricatorSettings, priceOld, selectionFeatureInfo)}</span> : null}
      {getPriceSection()}
      {showDiscount && price ? (
        <span className="product-info__price-save">
          {`${intl.formatMessage({id: "quotingTool.featureInfo.discountSavePercent"})} ${getPriceWithCurrency(fabricatorSettings, Math.trunc((priceOld - price) * 100) / 100, selectionFeatureInfo)} (${salePercentage}%)`}
        </span>
      ) : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    selectionFeatureInfo: store.selectionState.selectionFeatureInfo,
    featureInfoCount: store.selectionState.featureInfoCount, // to update component when price is changed
    fabricatorData: store.fabricatorState,
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    selectionInfoQuantity: store.selectionState.selectionInfoQuantity,
    qtActiveCategory: store.qtState.qtActiveCategory,
  };
};

const mapDispatchToProps = {

};

FeatureInfoPrice.propTypes = {
  feature: PropTypes.object,
  mainFeaturePrice: PropTypes.bool,
  accItemQuantity: PropTypes.number,
  size: PropTypes.string,
  unitAfter: PropTypes.bool,
  withTotalSlabCost: PropTypes.bool,
  showPrice: PropTypes.bool,
  cartItemEditFeature: PropTypes.shape(cartItemInterface),
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeatureInfoPrice)
);
